import React from 'react';
import './ComparisonCards.css';
import NODSImage from '../assets/images/NODS.png';
import ThermalsImage from '../assets/images/Thermals.png';

const ComparisonCards = () => {
    return (
        <div className="comparison-section">
            <div className="cards-container">
                <div className="screen night-vision-card">
                    <div className="screen-image"></div>
                    <div className="screen-static"></div>
                    <div className="screen-scanline"></div>
                    <div className="screen-lines"></div>
                    <div className="screen-overlay"></div>
                    <div className="screen-content">
                        <div className="screen-user">
                            <span className="name">NIGHT VISION</span>
                            <span className="description">Traditional Night Vision Devices (NVGs) amplify ambient light—moonlight, starlight, or artificial sources—using image intensifier tubes. The result? A brightened, green-hued image in low-light conditions.</span>
                        </div>
                        <div className="feature-content">
                            <p>NVGs offer sharper detail and depth perception—perfect for navigating terrain, identifying facial features, or reading signs. Because they amplify light rather than generate their own image, they consume less power, giving you longer battery life and more time in the field.</p>
                            <p>NVGs require ambient light—without moonlight, starlight, or artificial sources, their performance drops sharply. Fog, smoke, thick brush, or total darkness can block visibility entirely. Plus, sudden bright lights can overwhelm or temporarily blind the device, making them vulnerable to light blooming. </p>
                        </div>
                        {/* Moved device image inside content and made it a link */}
                        <a href="/night-vision" className="device-link">
                            <div className="device-image-container">
                                <img src={NODSImage} alt="Night Vision Device" />
                            </div>
                        </a>
                    </div>
                </div>

                <div className="screen thermal-card">
                    <div className="screen-image"></div>
                    <div className="screen-static"></div>
                    <div className="screen-scanline"></div>
                    <div className="screen-lines"></div>
                    <div className="screen-overlay"></div>  
                    <div className="screen-content">
                        <div className="screen-user">
                            <span className="name">THERMAL</span>
                            <span className="description">Thermal optics detect infrared radiation, or heat signatures, emitted by living beings, vehicles, and objects, allowing for precise identification in total darkness or challenging environments, without any reliance on visible light</span>
                        </div>
                        <div className="feature-content">
                            <p>Thermal optics perform flawlessly in zero-light conditions. Obstructions like fog, smoke, foliage, or camouflage don’t matter—thermals “see” heat, not light. Living beings stand out clearly by body heat, providing instant, reliable target detection and recognition.</p>
                            <p>Since thermals detect heat, fine details—like facial features or small objects—are harder to distinguish. Advanced tech means more power consumption, shorter battery life, and a significantly higher price tag compared to traditional NVGs, making thermals less accessible to most users.</p>
                        </div>
                        {/* Moved device image inside content and made it a link */}
                        <a href="/thermals" className="device-link">
                            <div className="device-image-container">
                                <img src={ThermalsImage} alt="Thermal Device" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <div className="cta-container">
                <div className="cta-content">
                    <h3>Want to dive deeper?</h3>
                    <p>Discover how to choose the right tool for your mission</p>
                    <a href="/article/night-vision-vs-thermal" className="read-more-btn">
                        Read More <span className="arrow">→</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ComparisonCards;